module.exports = __webpack_public_path__ + "img/banner1.a9527af.jpg";